module.exports = __webpack_public_path__ + "media/sport.40ec0cf3.mp4";